
import ClipboardTick from "../../../assets/filled/ClipboardTick.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function ClipboardTickIcon({ className, dataTestid = "ClipboardTickIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <ClipboardTick data-testid={dataTestid} className={classes} {...rest} />
  );
}
